import request from '../util/request'
class AppPublishService {
  constructor() {
    this.baseUrl = "/appconfig/t/app/publish";
  }
  getApkList(params) {
    return request.get(this.baseUrl, { params });
  }
  getHistory(id) {
    return request.get(`${this.baseUrl}/history/${id}`);
  }
  update(data) {
    return request({
      url: this.baseUrl,
      method: "post",
      data,
      transformRequest: [
        function (q) {
          let ret = "";
          for (let i in q) {
            ret += encodeURIComponent(i) + "=" + encodeURIComponent(q[i]) + "&";
          }
          return ret;
        }
      ],
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
}
export default new AppPublishService();
